import { RhCheckbox } from '../../../../../../dum';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { IAccount, IS_CLIENT } from '../account-form';
import { Box } from '@mui/material';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function RequiresOrderRequest() {
    const isClient = useWatch({
        name: IS_CLIENT,
    }) as IAccount['is_client'];

    if (!isClient) return null;

    return (
        <Box sx={{ ml: 2 }}>
            <RhCheckbox
                name={'requires_order_request'}
                label={shortLabel(FIELD_LABELS.requires_order_request)}
            />
        </Box>
    );
}
